import Header from 'src/components/CodeSectionPages/ProcessingRequests/Header';
import Section from 'src/components/CodeSectionPages/ProcessingRequests/Section';
import SectionPage from 'src/components/UCA/SectionPage';

export default function ProcessingRequests() {
  return (
    <SectionPage>
      <Header />
      <Section />
    </SectionPage>
  );
}
